export const QUESTION = 'How much do you walk in a normal day?'

export const OPTION_VALUES = {
  LESS_TWENTY: 'less_twenty',
  TWENTY_SIXTY: 'twenty_sixty',
  ONE_TWO_HOURS: 'one_two_hours',
  MORE_TWO_HOURS: 'more_two_hours',
}
